import { Spin } from 'platform-components';
import React from 'react';

export const SidePanelModeLoading = () => {
    return <Spin center />;
};
